import { ICostShareDTO, IFundingType } from './services/quote/dto'

export const LEVEL_FUNDED: IFundingType = 'level_funded'
export const FULLY_INSURED: IFundingType = 'fully_insured'
export const ACA_FULLY_INSURED: IFundingType = 'ACA'
export const FULLY_INSURED_NON_ACA: IFundingType = 'FI Large Group'
export const SELF_FUNDED: IFundingType = 'ASO'

export const addUnit = (
  input: number | string | undefined,
  unit: 'money' | 'one_based_percentage'
) => {
  const value = !!input ? input : 0

  let text = `${value}`
  if (unit === 'money') {
    text = `$${value}`
  } else if (unit === 'one_based_percentage') {
    text = `${Number(value) * 100}%`
  }

  return text
}

export const unitStringFromCostShare = (costShare: ICostShareDTO) =>
  addUnit(costShare.value, costShare.dataType)
